// extracted by css-extract-rspack-plugin
export default {"list":"ZH2Ng","tab":"U4uPU","tabLabel":"oabm_","tabSection":"ZSoxq"};